import React, { useState } from "react";
import Modal from "react-modal";
import { formatDateAndTime } from "../../common-data/Converts";
import FollowInfoFormV1 from "../followup/FollowInfoFormV1";
import ModalHeadAndClose from "../../payouts-wtf/common/ModalHeadAndClose";
import ManageLeadForm from "../followup/ManageLeadForm";
import {
  CallIcon1,
  EditIcon1,
  SlashCircleIcon,
  WhatsAppIcon,
} from "../../../images/icons/icons";

const FollowupSystemMobile = ({
  userInfoData,
  rowData,
  allFollowups,
  callFunction,
  isMarketing,
  isAdmin,
}) => {
  const initialModelValues = {
    isModOpen: false,
    cardName: "",
  };
  const [allModels, setAllModel] = useState(initialModelValues);

  const isClosed =
    rowData?.lead_status === "closed" || rowData?.lead_status === "converted";

  const sortedFollowupData =
    allFollowups?.length > 0
      ? [...allFollowups].sort(
          (a, b) => b?.follow_up_number - a?.follow_up_number
        )
      : [];

  function onCloseModal() {
    setAllModel(initialModelValues);
  }

  const handleWhatsAppButtonClick = (e, phoneNumber) => {
    e.preventDefault();
    window.open(`https://wa.me/+91${phoneNumber}`, "_blank");
  };

  const handleCallButtonClick = (e, phoneNumber) => {
    e.preventDefault();
    window.open(`tel:${phoneNumber}`, "_self");
  };

  return (
    <>
      <Modal
        isOpen={allModels.isModOpen}
        onRequestClose={onCloseModal}
        contentLabel="Modal"
        ariaHideApp={false}
      >
        <div
          className={`createNewCTOModalContainer add-new-lead-form ${
            allModels.cardName === "follow-up-date" ||
            allModels.cardName === "manage-lead"
              ? "mod-width-50p"
              : ""
          }`}
        >
          <ModalHeadAndClose
            title={`${
              allModels.cardName === "follow-up-date"
                ? "Followup Date/Time and Description"
                : allModels.cardName === "manage-lead"
                ? "Manage Lead"
                : ""
            }`}
            onClose={onCloseModal}
          />

          {allModels.cardName === "follow-up-date" ? (
            <FollowInfoFormV1
              userInfoData={userInfoData}
              rowData={rowData}
              followupStage={sortedFollowupData?.[0]?.follow_up_number || 0}
              callFunction={callFunction}
              allFollowups={allFollowups}
              closeModal={onCloseModal}
            />
          ) : allModels.cardName === "manage-lead" ? (
            <ManageLeadForm
              userInfoData={userInfoData}
              rowData={rowData}
              callFunction={callFunction}
              closeModal={onCloseModal}
              followupStage={allFollowups?.[0]?.follow_up_number || 0}
            />
          ) : null}
        </div>
      </Modal>

      <div className="followup-cards-container">
        <div className="followup-cards-scrollable">
          {allFollowups?.length > 0 &&
            allFollowups.map((followup, index) => {
              const { formattedDate, formattedTime } = formatDateAndTime(
                followup?.date_added
              );

              return (
                <div className="followup-card" key={index}>
                  <div className="followup-card-top">
                    <span className="added-date">{formattedDate || ""}</span>
                    <span className="added-time">{formattedTime || ""}</span>
                  </div>

                  <div className="followup-stages">
                    <span className="followup-stage">
                      {followup?.follow_up_number || 0}
                    </span>

                    <span className="followup-status">
                      {rowData?.cutomer_intent?.replace(/_/g, " ") || ""} |{" "}
                      {followup?.follow_up_status?.replace(/_/g, " ") || "NA"}
                    </span>
                  </div>

                  {followup?.follow_up_status !== "pending" ? (
                    <div className="added-by-row">
                      <span className="addedby-label">Added By -</span>
                      <b className="added-by">
                        {followup?.added_by_name || "NA"}
                      </b>
                    </div>
                  ) : null}

                  <div className="followup-remarks">
                    {followup?.follow_up_status === "pending" &&
                    !isMarketing ? (
                      <button
                        type="button"
                        className="update-new-followup-btn"
                        disabled={isClosed || allFollowups?.length >= 15}
                        style={{
                          cursor:
                            isClosed || allFollowups?.length >= 15
                              ? "not-allowed"
                              : "pointer",
                        }}
                        onClick={() =>
                          (!isClosed || !allFollowups?.length >= 15) &&
                          setAllModel((prevs) => ({
                            ...prevs,
                            isModOpen: true,
                            cardName: "follow-up-date",
                          }))
                        }
                      >
                        Create New Follow-up
                      </button>
                    ) : (
                      <span className="remarks">
                        {followup?.remarks || "NA"}
                      </span>
                    )}
                  </div>
                </div>
              );
            })}
        </div>

        {!isMarketing && (
          <div className="followup-btns">
            <div className="followup-btn-box">
              <button
                className="followup-btn call-btn"
                onClick={(e) => handleCallButtonClick(e, rowData?.mobile)}
              >
                <CallIcon1 />
              </button>

              <span className="btn-label">Call lead</span>
            </div>

            <div className="followup-btn-box">
              <button
                className="followup-btn whatsapp-btn"
                onClick={(e) => handleWhatsAppButtonClick(e, rowData?.mobile)}
              >
                <WhatsAppIcon color="#13CE66" />
              </button>

              <span className="btn-label">WhatsApp</span>
            </div>

            <div className="followup-btn-box">
              <button
                className="followup-btn edit-btn"
                disabled={isClosed || allFollowups?.length >= 15}
                style={{
                  cursor:
                    isClosed || allFollowups?.length >= 15
                      ? "not-allowed"
                      : "pointer",
                }}
                onClick={() =>
                  (!isClosed || !allFollowups?.length >= 15) &&
                  setAllModel((prevs) => ({
                    ...prevs,
                    isModOpen: true,
                    cardName: "follow-up-date",
                  }))
                }
              >
                <EditIcon1 />
              </button>

              <span className="btn-label">Follow-up</span>
            </div>

            {/* {isAdmin && (
              <div className="followup-btn-box">
                <button
                  className="followup-btn manage-btn"
                  disabled={isClosed}
                  style={{
                    cursor: isClosed ? "not-allowed" : "pointer",
                  }}
                  onClick={() =>
                    !isClosed &&
                    setAllModel((prevs) => ({
                      ...prevs,
                      isModOpen: true,
                      cardName: "manage-lead",
                    }))
                  }
                >
                  <SlashCircleIcon />
                </button>

                <span className="btn-label">Manage</span>
              </div>
            )} */}
          </div>
        )}
      </div>
    </>
  );
};

export default FollowupSystemMobile;
